import classNames from "classnames";
import { FC, HTMLAttributes, ReactNode } from "react";

type PointsExchangeActionCardProps = {
  label: ReactNode;
  value: ReactNode;
  leadingIcon?: ReactNode;
  action?: ReactNode;
  variant?: "highlight" | "default";
} & Omit<HTMLAttributes<HTMLDivElement>, "title">;

const PointsExchangeActionCard: FC<PointsExchangeActionCardProps> = ({ label, value, leadingIcon, action, variant = "default", className, ...props }) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-between gap-3 rounded-md px-4 py-3",
        variant === "highlight" ? "border border-dashed border-border-primary bg-background-primary-lighter" : "bg-background-minimal",
        className,
      )}
      {...props}
    >
      <div className="flex min-w-0 items-center gap-3">
        {leadingIcon && (
          <div className="flex size-10 shrink-0 items-center justify-center rounded-md border border-border-subtle bg-background-default text-font-subtle">
            {leadingIcon}
          </div>
        )}
        <div className="flex min-w-0 flex-col gap-1">
          <span className="text-xs font-medium tracking-wider text-font-subtle uppercase">{label}</span>
          <span
            className={classNames(
              "truncate font-semibold text-font-default",
              variant === "highlight" ? "text-xl tracking-widest md:text-2xl" : "text-base",
            )}
          >
            {value}
          </span>
        </div>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};

export default PointsExchangeActionCard;
